import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit'
import { useSelector } from 'react-redux';
import { AuctionType } from 'types/vehicle';

type CreateAuctionState = {
  frontlineDialogOpened: AuctionType | null;
  confirmFrontlineDialogOpened: AuctionType | null;
}

const initialState: CreateAuctionState = {
  frontlineDialogOpened: null,
  confirmFrontlineDialogOpened: null,
};

const createAuctionSlice = createSlice({
  name: 'createAuction',
  initialState,
  reducers: {
      setAlternativeDialogOpened: (state, action: PayloadAction<AuctionType | null>) => {
        state.frontlineDialogOpened = action.payload;
      },
      setConfirmAlternativeDialogOpened: (state, action: PayloadAction<AuctionType | null>) => {
        state.confirmFrontlineDialogOpened = action.payload;
      },
    }
});

export const useFrontlineDialogOpened = () => {
  const frontlineDialogOpened = useSelector<{ createAuction: CreateAuctionState }, AuctionType | null>(
    state => state.createAuction.frontlineDialogOpened
  );
  return frontlineDialogOpened;
};

export const useConfirmFrontlineDialogOpened = () => {
  const confirmFrontlineDialogOpened = useSelector<{ createAuction: CreateAuctionState }, AuctionType | null>(
    state => state.createAuction.confirmFrontlineDialogOpened
  );
  return confirmFrontlineDialogOpened;
};

export const { setAlternativeDialogOpened, setConfirmAlternativeDialogOpened } = createAuctionSlice.actions
export default createAuctionSlice;
